import React from "react";
import { TspCard, TspBarChart } from "../../../components/primitives";

// City visits recorded per year (by visit date), the same years as Year Wise
// Book Distribution so the two read side by side.
// `data` = [{ name: "2024", visits }] from buildVisitWise.
const VISIT_SERIES = [{ key: "visits", name: "City Visits", color: "#7c3aed" }];

export default function VisitWiseChart({ data }) {
  const chartData = data || [];
  const hasVisits = chartData.some((row) => Number(row.visits) > 0);

  return (
    <TspCard title="Number of Visits Wise Chart" className="tsp-dashboard-chart-card">
      {hasVisits ? (
        <TspBarChart data={chartData} xKey="name" series={VISIT_SERIES} height="100%" minHeight={220} />
      ) : (
        <p className="tsp-muted-text tsp-dashboard-chart-empty">No city visits recorded yet.</p>
      )}
    </TspCard>
  );
}
